import RmSetCloseSIMLockModal from './rm-set-close-SIM-lock-modal.vue'
export default RmSetCloseSIMLockModal
